const getters = {
    JTSJLR_unitConfig: state => state.JTSJLR.unitConfig,
    JTSJLR_colsConfig: state => state.JTSJLR.colsConfig,
    JTSJLR_dimConfig: state => state.JTSJLR.dimConfig,
    JTSJLR_unitFactory: state => state.JTSJLR.unitFactory,
}

export default getters